import { useTranslation } from "react-i18next";

export const useGetTranslatedDay = () => {
  const { t } = useTranslation("translation");

  const getTranslatedDay = (day: number) => {
    switch (day) {
      case 0:
        return t("Days.sunday");
      case 1:
        return t("Days.monday");
      case 2:
        return t("Days.tuesday");
      case 3:
        return t("Days.wednesday");
      case 4:
        return t("Days.thursday");
      case 5:
        return t("Days.friday");
      case 6:
        return t("Days.saturday");
      default:
        return day.toString();
    }
  };

  return { getTranslatedDay };
};
